import { useTranslation } from 'react-i18next';

import { Link as ChakraLink, LinkProps, StyleProps } from '@chakra-ui/react';
import { ArrowLeftSmallIcon, ArrowRightSmallIcon } from '@udacity/chakra-uds-icons';

export function ExternalLink(props: LinkProps & StyleProps & { withArrow?: boolean }) {
  const { i18n } = useTranslation();
  const languageDir = i18n.dir();

  const { withArrow, children, ...linkProps } = props;

  return (
    <ChakraLink isExternal {...linkProps}>
      {children} {withArrow && languageDir === 'ltr' && <ArrowRightSmallIcon h='32px' w='32px' />}
      {withArrow && languageDir === 'rtl' && <ArrowLeftSmallIcon h='32px' w='32px' />}
    </ChakraLink>
  );
}
